import { useContext, useEffect, useState } from 'react';
import { useFieldArray, useForm, useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormLabel, FormItem, FormMessage, } from '@/components/shadcn/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Command, CommandInput, CommandGroup, 
  CommandEmpty, CommandItem, CommandList } from '@/components/shadcn/ui/command';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { InputMasks } from '@/components/shadcn/ui/input';
import { Calendar } from '@/components/shadcn/ui/calendar';
import { Button } from '@/components/shadcn/ui/button';
import { CalendarIcon, Check, ChevronsUpDown } from 'lucide-react';
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';
import { cn } from '@/lib/utils';
import { useSourceContext } from '@/pages/configurations/source/SourceContext';
import { MentionsInput, Mention } from 'react-mentions';
import mentionStyles from './mentionStyles';

import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { toast, useToast } from '@/components/shadcn/ui/use-toast';
import { useClients } from '@/hook/useClients';
import { useBusinessSource } from '@/hook/useBusinessSource';
import { useActivityType } from '@/hook/useActivityType';
import { useBusiness } from '@/hook/useBusiness';
import { useParams } from 'react-router-dom';
import { BusinessUpdateInterface } from '@/entities/business';
import { useIndicators } from '@/hook/useIndicators';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@/components/shadcn/ui/select';
import { useAuthContext } from '@/context/AuthContext';
import React from 'react';
interface ClientForm{
  id:number;
  fantasyName:string;
}

interface TypeForm{
  id:number;
  name:string;
}

interface SourceType {
  id: number,
  description: string
}

interface IndicatorForm {
  id: number,
  name: string
}

const participantes = [
  { id: 1, display: 'Chico' },
  { id: 2, display: 'Beltrão' },
  { id: 3, display: 'Maria' }
];

// const indicadores = [
//   { id: 1, name: 'Chico' },
//   { id: 2, name: 'Beltrão' },
//   { id: 3, name: 'Maria' }
// ];

// const clients = [
//   { label: 'Empresa A', value: 'en' },
//   { label: 'Empresa B', value: 'fr' },
//   { label: 'Empresa C', value: 'de' },
//   { label: 'Empresa D', value: 'es' },
//   { label: 'Empresa E', value: 'pt' },
//   { label: 'Empresa F', value: 'ru' },
//   { label: 'Empresa G', value: 'ja' },
//   { label: 'Empresa H', value: 'ko' },
//   { label: 'Empresa I', value: 'zh' },
// ] as const;

// const types = [
//   { label: 'Venda', value: 'venda' },
//   { label: 'Implementação', value: 'implementaco' },
//   { label: 'Pós-Venda', value: 'posvenda' },
// ] as const;

const Details = () => {
  // const { sources, addSource } = useSourceContext();
  const { control, getValues, setValue, handleSubmit } = useFormContext();
  const [openClientSelect, setOpenClientSelect] = useState(false);
  const [openTypeSelect, setOpenTypeSelect] = useState(false);
  const [openSourceSelect, setOpenSourceSelect] = useState(false);
  const [openIndicatorSelect, setOpenIndicatorSelect] = useState(false);
  const { clientsUse } = useClients();
  const { updateBusiness } = useBusiness();
  const { businessSources } = useBusinessSource();
  const { indicators } = useIndicators();
  const {activityTypes } = useActivityType();
  const [sources, setSources] = useState<SourceType[]>([]);
  const [clients, setFormClient] = useState<ClientForm[]>([]);
  const [types, setFormTypes] = useState<TypeForm[]>([]);
  const [indicadores, setIndicatorsForm] = useState<IndicatorForm[]>([]);
  const { business, businessEdit, setBusinessEdit, businessEdit2, setBusinessEdit2, fetchbusinessById, setbusiness } = useBusinessDetailContext();
  const [getBusiness, setGetBusiness] = useState<any>();
  const [cliente, setCliente] = useState({});
  const [openDtInicio, setOpenDtInicio] = useState(false);
  const [openPrevision, setOpenPrevision] = useState(false);
  // const [ businessId, setBId] = useState(0);
  const {toast} = useToast();
  const {leadId} = useParams<{leadId:string}>();
  const leadId2Set = Number(leadId);
  const {business2} = useBusiness(leadId2Set);
  const {accessToken} = useAuthContext(); 

  const clientsAdd = clientsUse.map((client)=>({
    id:client.id,
    fantasyName: client.fantasyName,
  }));

  const typesAdd = activityTypes.map((type)=>({
    id: type.id,
    name: type.name,
  }));

  const sourceAdd = businessSources.map((source) => ({
    id: source.id,
    description: source.description
  }));

  const indicatorsAdd = indicators.map((indicator) =>({
    id: indicator.id,
    name: indicator.name
  }));

  const values = getValues();

  useEffect(() => {
    if (!businessEdit2) return;
    // console.log(businessEdit2);
    setGetBusiness(business);
    setFormClient(clientsAdd);
    setFormTypes(typesAdd);
    setSources(sourceAdd);
    setIndicatorsForm(indicatorsAdd);
    if(businessEdit2.client){
    setValue('client', businessEdit2.client.id || businessEdit2.client);}
    setValue('email', businessEdit2.email);
    setValue('descricao',  businessEdit2.descricao);
    setValue('dtinicio', businessEdit2.dtinicio);
    setValue('tel', businessEdit2.tel);
    setValue('situacao', businessEdit2.situacao);
    setValue('previsao', businessEdit2.previsao);
    setValue('motivo', businessEdit2.motivo);
    setValue('idfontenegocio', businessEdit2.idfontenegocio);
    setValue('observacao', businessEdit2.observacao);
    setValue('idtiponegocio', businessEdit2.idtiponegocio);
    setValue('observacao', businessEdit2.observacao);
    // setGetBusiness(business);
    // console.log(getBusiness);
    // console.log(business);   
    // console.log(leadId);     
    // console.log(getValues());
  }, [businessEdit2]);

  const onSubmit = async (data: any) =>{
    
    const updateData:BusinessUpdateInterface = {
      description: data.descricao,
      contactNumber: data.tel,
      observation: data.observacao,
      prevision: data.previsao,
      closedAt: undefined,
      status: data.status,
      startedAt: data.dtinicio,
      updatedAt: new Date(),
      email: data.email,
      clientId: data.client,
      activityTypesId: data.idtiponegocio,
      businessSourceId: data.idfontenegocio
    };
    // console.log(updateData);
    const result = await updateBusiness(leadId2Set,updateData);
    
    if (result != undefined){
      if (result.success) {
      toast({ description: "Dados alterados com sucesso!" });
    } else {
      toast({ description: "Ocorreu um erro! Dados não foram salvos.", variant: "destructive" });
    }}

  };

  {/*console.log(getBusiness);*/ return (
    <div className='flex bg-indigo-200 justify-center h-screen w-screen'>
      {/** Descrição */}
      <div className='flex bg-white mx-4 p-2 rounded-lg border gap-2 h-[90%] justify-end'>
      <form className='py-3 px-3 flex rounded-xl flex-col h-auto max-h-max bg-white w-[1000px] gap-4' onSubmit={handleSubmit(onSubmit)}>
        <FormField
          control={control}
          name="descricao"
          rules={{ required: "Preencha o campo" }}
          render={({ field }) => (
            <FormItem className='flex flex-col w-full'>
              <FormLabel className='text-slate-900 pb-2.5'>Descrição</FormLabel>
              <FormControl>
                <InputMasks
                  placeholder="Descrição"
                  className="resize-none text-muted-foreground bg-slate-50 hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white"
                  {...field}
                  onChange={(e: { target: { value: any; }; }) => {
                    // Atualizando o valor no formulário
                    setValue('descricao', e.target.value);
                    setBusinessEdit2(getValues());
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />

        {/** tipo negocio */}
        <FormField
          control={control}
          name='idtiponegocio'
          rules={{ required: "Preencha o campo" }}
          render={({ field }) => (
            <FormItem className='flex flex-col'>
              <FormLabel className='text-slate-900 pb-2.5'>Tipo Negócio</FormLabel>
              <Popover open={openTypeSelect} onOpenChange={setOpenTypeSelect}>
                <PopoverTrigger asChild>
                  <FormControl>
                    <Button
                      
                      aria-expanded={openClientSelect}
                      variant='outline' 
                      role='combobox'
                      className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                        !field.value && 'text-muted-foreground font-normal'
                      )}>
                      {field.value 
                        ? activityTypes.find(
                          (type) => type.id === field.value
                        )?.name
                        : 'Selecione um tipo'
                      }
                      <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                    </Button>
                  </FormControl>
                </PopoverTrigger>
                <PopoverContent className='w-inherit p-0'>
                  <Command>
                    <CommandInput placeholder='Procure um tipo' />
                    <CommandEmpty>Não encontrado</CommandEmpty>
                    <CommandList>
                      <CommandGroup>
                        {activityTypes.map((type) => (
                          <CommandItem
                            value={type.name}
                            key={type.id}
                            onSelect={() => {
                              // console.log(businessEdit2);
                              setValue('idtiponegocio', type.id);
                              setOpenTypeSelect(false);
                              setBusinessEdit2(getValues());
                            }}
                          >
                            <Check
                              className={cn('mr-2 h-4 w-4',
                                type.id === field.value
                                  ? 'opacity-100'
                                  : 'opacity-0'
                              )}
                            />
                            <span>{type.name}</span>
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </FormItem>
          )}
        />

        {/** Cliente */}
        <div className='flex items-center justify-start gap-4'>
          {/** Número do telefone */}
          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name='tel'
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Telefone</FormLabel>
                <FormControl>
                  <InputMasks
                    {...field}
                    className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white'
                    mask="(99) 99999-9999"
                    placeholder="Digite o número"
                    onChange={(e:any) => {
                      const newValue = e.target.value;
                      // console.log(newValue);
                      
                      // Atualiza o valor no formulário e no estado
                      field.onChange(newValue);
                      setValue('tel', newValue);
                      
                      // Atualiza o estado de businessEdit2 com os novos valores
                      setBusinessEdit2({
                        ...getValues(),  // Obtém os valores mais recentes do formulário
                      });
                      // console.log(businessEdit2);
                      // Caso você precise do businessEdit2 atualizado em tempo real, use um useEffect para monitorar
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField 
            control={control}
            rules={{ required: "Preencha o campo" }}
            name='client'
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Cliente</FormLabel>
                <Popover open={openClientSelect} onOpenChange={setOpenClientSelect}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        
                        aria-expanded={openTypeSelect}
                        variant='outline' 
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value 
                          ? clientsUse.find(
                            (client) => client.id === field.value
                          )?.fantasyName
                          : 'Selecione o Cliente'  
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder={business ? clientsUse.find((c)=> c.id === business.clientId)?.fantasyName : 'Procure um cliente'} />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {clientsUse.map((client) => (
                            <CommandItem 
                              value={client.fantasyName}
                              key={client.id}
                              onSelect={() => {
                                setValue('client', client.id);
                                updateBusiness(leadId2Set,{clientId: client.id});
                                toast({description: 'Cliente atualizado com sucesso!'});
                                setOpenClientSelect(false);
                                setBusinessEdit(getValues());
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  client.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              <span>{client.fantasyName}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />

        </div>

        <div className='flex items-center justify-start gap-4'>
          {/** Data de Início */}
          <FormField
            control={control}
            name="dtinicio"
            render={({ field }) => (
              <FormItem className="flex flex-col w-1/2">
                <FormLabel className='text-slate-900 pb-2.5'>Data de Início</FormLabel>
                <Popover open={openDtInicio} onOpenChange={setOpenDtInicio}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        
                        variant={'outline'}
                        className={cn(
                          'w-full pl-3 text-left font-normal bg-slate-50 focus:bg-white text-muted-foreground',
                          !field.value && 'text-muted-foreground'
                        )}
                      >
                        {field.value ? (
                          format(field.value, 'PPP', {locale: ptBR})
                        ) : (
                          <span>Escolha uma data</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={field.value}
                      onSelect={field.onChange}
                      onDayClick={(date) => {
                        setValue('dtinicio', date);
                        setBusinessEdit2(getValues());
                        setOpenDtInicio(false);
                      }}
                  
                    />
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
            
          {/** Data da Previsão */}
          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name="previsao"
            render={({ field }) => (
              <FormItem className="flex flex-col w-1/2">
                <FormLabel className='text-slate-900 pb-2.5'>Data de Previsão</FormLabel>
                <Popover open={openPrevision} onOpenChange={setOpenPrevision}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        
                        variant={'outline'}
                        className={cn(
                          'w-full pl-3 text-left font-normal bg-slate-50 focus:bg-white text-muted-foreground',
                          !field.value && 'text-muted-foreground'
                        )}
                      >
                        {field.value ? (
                          format(field.value, 'PPP', {locale: ptBR})
                        ) : (
                          <span>Escolha uma data</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={field.value}
                      onSelect={field.onChange}
                      onDayClick={(date) => {
                        setValue('previsao', date);
                        setBusinessEdit2(getValues());
                        setOpenPrevision(false);
                      }}
                      disabled={(date) => {
                        const dtinicio = getValues().dtinicio;
                        if (!dtinicio) return true;
                        return date < dtinicio || date < new Date();
                      }}
                      initialFocus
                      locale={ptBR}
                    />
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
            
        </div>
        <div className='flex items-center gap-2'>
          {/** fonte */}
          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name='idfontenegocio'
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Fonte Negócio</FormLabel>
                <Popover open={openSourceSelect} onOpenChange={setOpenSourceSelect}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        
                        aria-expanded={openSourceSelect}
                        variant='outline' 
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value 
                          ? businessSources.find(
                            (source) => source.id === field.value
                          )?.description
                          : 'Selecione'
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder='Procure' />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {businessSources.map((source) => (
                            <CommandItem 
                              value={source.description}
                              key={source.id}
                              onSelect={() => {
                                setValue('idfontenegocio', source.id);
                                setOpenSourceSelect(false);
                                setBusinessEdit2(getValues());
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  source.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              <span>{source.description}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
          <FormField
          control={control}
          name="email"
          rules={{ required: "Preencha o campo" }}
          render={({ field }) => (
            <FormItem className='flex flex-col w-full'>
              <FormLabel className='text-slate-900 pb-2.5'>Email</FormLabel>
              <FormControl>
                <InputMasks
                  placeholder="Email"
                  className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}{...field}
                  onChange={(e: { target: { value: any; }; }) => {
                    // Atualizando o valor no formulário
                    setValue('email', e.target.value);
                    setBusinessEdit2(getValues());
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
        </div>

        {/** Observação */}
        <FormField
          control={control}
          rules={{ required: "Preencha o campo" }}
          name="observacao"
          render={({ field }) => (
            <FormItem className='flex flex-col w-full'>
              <FormLabel className='text-slate-900 pb-2.5'>Observação</FormLabel>
              <FormControl>
                <InputMasks
                  placeholder=''
                  className="resize-none bg-slate-50 hover:bg-slate-100 focus:bg-white hover:text-slate-900 text-muted-foreground"
                  {...field}
                  onChange={(e: { target: { value: any; }; }) => {
                    // Atualizando o valor no formulário
                    setValue('observacao', e.target.value);
                    setBusinessEdit2(getValues());
                    // Aqui você pode acessar o valor em tempo real // Para exibir no console o valor enquanto digita
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
      <Button onClick={() =>{
        const data = getValues();
        onSubmit(data)}}>Salvar informações</Button>
      </form>
      </div>
    </div>
  );}
};

export default Details;
